import { Card } from "react-bootstrap";

export const ValueSellingFrameworkPlaceholder = ({ numberOfCards = 1, widthClass = 'col-md-6', numberOfLines = 3 }) => {
  return (
    <>
      {Array.from({ length: numberOfCards }).map((_, index) => (
        <div className={widthClass} key={index}>
          <div className="battle_card_block placeholder-card placeholder-glow">
            <Card className="battle_card_custom">
              <Card.Header className="battle_card_header placeholder bg-dark">
               &nbsp; {/* <div className="placeholder-line shimmer"> &nbsp; </div> */}
              </Card.Header>
              <Card.Body className="battle_card_body">
                <div className="battle_content_block">
                  <div className="row">
                    {[...Array(numberOfLines)].map((_, i) => (
                      <div className="col-md-12 pr-0 pl-0" key={i}>
                        <div className="right_battle_content_block">
                            <span className={`placeholder placeholder-xs ${i % 2 != 0 ? "w-75" : 'w-100'} `} style={{fontSize: '8px'}}> &nbsp; </span> 
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      ))}
    </>
  );
};
